
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";

import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

export default function ListBlog() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Blog',
            url: '/dashboard/Blog'
        },
        {
            name: 'Group List',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Group List"></HeaderOfPage>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
                    <div className="lg:col-span-1" dir="rtl">
                        <NewBlogCategory reloaditem={reloadgame} key={key}></NewBlogCategory>
                    </div>
                    <div className="lg:col-span-3">
                        <ListofBlog key={key}></ListofBlog>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBlog() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [loading, setLoading] = useState<boolean>(true);
    
    // Language selector state - default to Persian (fa)
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);
    const [activeLang, setActiveLang] = useState<string>('fa'); // Default to Persian
    
    // Load languages
    const loadLanguages = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
            // Set default to Persian if available, otherwise first language
            const faLang = mapped.find((l: { code: string; label: string }) => l.code === 'fa');
            if (faLang) {
                setActiveLang('fa');
            } else if (mapped.length > 0) {
                setActiveLang(mapped[0].code);
            }
        } catch (e) {
            console.error('Error loading languages:', e);
            const fallback = [
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ];
            setLanguages(fallback);
            setActiveLang('fa');
        }
    };
    
    // Helper function to get multilingual value
    const getMultilingualValue = (field: any, lang: string): string => {
        if (!field) return '';
        if (typeof field === 'string') return field;
        if (typeof field === 'object') {
            return field[lang] || field.en || field.fa || field.ku || field.ar || field.tr || '';
        }
        return '';
    };

    const getalldata = async () => {
        setError(null);
        setLoading(true);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/bloggroup',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(res.data.message);
        } catch (error: any) {
            setError(error.response?.data?.message || t('Error loading groups'));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading groups'),
            });
        } finally {
            setLoading(false);
        }
    }
    
    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/bloggroup/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Group deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    getalldata();
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: error.response?.data?.message || t('Error deleting group'),
                    });
                }
            }
        });
    }
    
    useEffect(() => {
        loadLanguages();
        getalldata();
    }, []);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];

    return (
        <div className="space-y-4" dir="rtl">
            {/* Action Buttons */}
            <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={() => getalldata()}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                {t('Reload')}
                            </div>
                        </button>
                    </div>
                    {/* Language Selector */}
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">زبان:</span>
                        <div className="flex gap-2 flex-wrap">
                            {langList.map((lang) => (
                                <button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setActiveLang(lang.code)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                        activeLang === lang.code
                                            ? 'bg-blue-600 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Groups Table */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {error && (
                    <div className="p-4 bg-red-50 border-r-4 border-red-500 text-red-700">
                        {error}
                    </div>
                )}
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Code')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Name')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('URL')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Action')}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {list && list.length > 0 ? (
                                list.map((item: any) => {
                                    const displayName = getMultilingualValue(item.name, activeLang);
                                    const displayUrl = getMultilingualValue(item.url, activeLang);
                                    return (
                                        <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-6 py-4">
                                                <div className="text-sm font-medium text-gray-900">{item.code || 'N/A'}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="text-sm font-medium text-gray-900">{displayName || 'بدون نام'}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="text-sm text-gray-500">{displayUrl || 'N/A'}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-2">
                                                    <a
                                                        href={`/dashboard/Blog/GroupEdit/${item.id}`}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                                                        title="ویرایش"
                                                    >
                                                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                        {t('Edit')}
                                                    </a>
                                                    <button
                                                        onClick={() => deleted(item.id)}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                                                        title="حذف"
                                                    >
                                                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                        {t('Delete')}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={4} className="px-6 py-12 text-center">
                                        <div className="flex flex-col items-center">
                                            <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                            <p className="text-gray-500 text-lg">گروهی یافت نشد</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
type LanguageCode = string;

interface MultilingualField {
    [key: string]: string;
}

interface BlogGroupData {
    name: MultilingualField;
    url: MultilingualField;
    keywords: MultilingualField;
    description: MultilingualField;
    code: string;
    parent: string | null;
}

function NewBlogCategory({ reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [data, setData] = useState<BlogGroupData>({
        name: {},
        url: {},
        keywords: {},
        description: {},
        code: '',
        parent: null
    });
    const [error, setError] = useState(null);
    const [key, setKey] = useState(1);
    const [saving, setSaving] = useState(false);
    const [activeLang, setActiveLang] = useState<LanguageCode>('fa'); // Default to Persian
    const [languages, setLanguages] = useState<Array<{ code: LanguageCode; label: string }>>([]);

    // Load languages
    const loadLanguages = async (): Promise<Array<{ code: LanguageCode; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data.message || [];
            const mappedLanguages = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0))
                .map((lang: any) => ({
                    code: lang.code as LanguageCode,
                    label: lang.label
                }));
            setLanguages(mappedLanguages);
            // Set default to Persian if available, otherwise first language
            const faLang = mappedLanguages.find((l: { code: LanguageCode; label: string }) => l.code === 'fa');
            if (faLang) {
                setActiveLang('fa');
            } else if (mappedLanguages.length > 0) {
                setActiveLang(mappedLanguages[0].code);
            }
            return mappedLanguages;
        } catch (error) {
            console.error('Error loading languages:', error);
            const fallbackLanguages = [
                { code: 'ku' as LanguageCode, label: 'Kurdish' },
                { code: 'fa' as LanguageCode, label: 'فارسی' },
                { code: 'en' as LanguageCode, label: 'English' },
                { code: 'ar' as LanguageCode, label: 'العربية' },
                { code: 'tr' as LanguageCode, label: 'Türkçe' }
            ];
            setLanguages(fallbackLanguages);
            setActiveLang('fa'); // Default to Persian in fallback
            return fallbackLanguages;
        }
    };

    // Helper function to initialize multilingual field
    const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
        if (!field) {
            const obj: MultilingualField = {};
            languageCodes.forEach(code => obj[code] = '');
            return obj;
        }
        if (typeof field === 'string') {
            const obj: MultilingualField = {};
            languageCodes.forEach(code => obj[code] = field);
            return obj;
        }
        if (typeof field === 'object') {
            const obj: MultilingualField = { ...field };
            languageCodes.forEach(code => {
                if (!obj[code]) obj[code] = '';
            });
            return obj;
        }
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    };

    // Helper function to safely access multilingual fields
    const getMultilingualValue = (field: MultilingualField, lang: LanguageCode): string => {
        return field[lang] || '';
    };

    const setName = (name: string) => {
        const updatedName = {
            ...data.name,
            [activeLang]: name
        };

        const updatedUrl = { ...data.url };
        updatedUrl[activeLang] = String(changeUrl(name)); // Slug generated for active language

        setData((prev: BlogGroupData) => ({
            ...prev,
            url: updatedUrl,
            name: updatedName
        }));
    }
    const save = async () => {
        setError(null);
        setSaving(true);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/bloggroup',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Group added successfully'),
                timer: 1500,
                showConfirmButton: false
            });

            // Reset form with current languages
            const languageCodes = languages.length > 0 
                ? languages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            const emptyMultilingualField: MultilingualField = {};
            languageCodes.forEach(code => emptyMultilingualField[code] = '');
            setData({
                name: { ...emptyMultilingualField },
                url: { ...emptyMultilingualField },
                keywords: { ...emptyMultilingualField },
                description: { ...emptyMultilingualField },
                code: '',
                parent: null
            });
            
            reloaditem();
            let x = key + 1;
            setKey(x);
        } catch (error: any) {
            const errorMessage = error.response?.data?.message || 'خطا در ذخیره گروه بلاگ';
            setError(errorMessage);
            
            if (error.response?.data?.code != null) {
                Swal.fire({
                    icon: 'error',
                    title: t('Error'),
                    text: `"${getMultilingualValue(data.url, activeLang)}" slug is available.`,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('Error'),
                    text: errorMessage,
                });
            }
        } finally {
            setSaving(false);
        }
    }

    useEffect(() => {
        loadLanguages();
    }, []);

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";
    return (
        <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">{t('New Category')}</h3>
            
            {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800">{error}</p>
                </div>
            )}

            <form key={key}>
                {/* Language Selector */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-white mb-2">
                        زبان / Language
                    </label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-700 text-white hover:bg-gray-600'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Code <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={data.code}
                        className={`${inputstyle} ${error != null && error['code'] != undefined && 'bg-red-100 border-red-300'} `}
                        placeholder="مثال: CAT001"
                        onChange={(e) => setData((prev: BlogGroupData) => ({ ...prev, code: e.target.value }))}
                        required
                    />
                    {error != null && error['code'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['code']['message']}</small>}
                    <p className="mt-1 text-xs text-gray-500">کد یکتای گروه (به انگلیسی و بدون فاصله)</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.name, activeLang)}
                        className={`${inputstyle} ${error != null && error['name'] != undefined && 'bg-red-100 border-red-300'} `}
                        placeholder="نام گروه را وارد کنید"
                        onChange={(e) => { setName(e.target.value); }}
                        required
                    />
                    {error != null && error['name'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['name']['message']}</small>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        URL ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        value={getMultilingualValue(data.url, activeLang)}
                        type="text"
                        className={`${inputstyle} ${error != null && error['url'] != undefined && 'bg-red-100 border-red-300'} `}
                        placeholder="slug"
                        onChange={(e) => setData((prev: BlogGroupData) => ({
                            ...prev,
                            url: {
                                ...prev.url,
                                [activeLang]: e.target.value
                            }
                        }))}
                        required
                    />
                    <p className="mt-1 text-xs text-gray-500">به صورت خودکار از نام تولید می‌شود</p>
                    {error != null && error['url'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['url']['message']}</small>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        rows={3}
                        className={inputstyle}
                        onChange={(e) => setData((prev: BlogGroupData) => ({
                            ...prev,
                            keywords: {
                                ...prev.keywords,
                                [activeLang]: e.target.value
                            }
                        }))}
                        placeholder="کلمات کلیدی (با کاما جدا کنید)" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        rows={4}
                        className={inputstyle}
                        onChange={(e) => setData((prev: BlogGroupData) => ({
                            ...prev,
                            description: {
                                ...prev.description,
                                [activeLang]: e.target.value
                            }
                        }))}
                        placeholder="توضیحات گروه" />
                </div>
                <div className="flex justify-end pt-2">
                    <button type="button"
                        onClick={(e) => { save() }}
                        disabled={saving || !getMultilingualValue(data.name, activeLang) || !data.code || !getMultilingualValue(data.url, activeLang)}
                        className="inline-flex items-center justify-center gap-x-2 px-6 py-2.5 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                    >
                        {saving ? (
                            <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                در حال ذخیره...
                            </>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                {t('Add Category')}
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    )
}